import {
    FETCH_LANGUAGE,
    FETCH_LANGUAGE_SUCCESS,
    FETCH_LANGUAGE_FAILED,
    EDIT_LANGUAGE
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { onValue, set, push, remove, update } from "firebase/database";
import { getLangKey } from "../other/getLangKey";

export const fetchLanguages = () => (dispatch) => {
    const { languagesRef } = firebase;

    if (!languagesRef) {
        console.warn("[languageactions] DB not ready (languagesRef null), retrying in 300ms...");
        setTimeout(() => {
            dispatch(fetchLanguages());
        }, 300);
        return;
    }

    dispatch({ type: FETCH_LANGUAGE, payload: null });

    onValue(languagesRef, (snapshot) => {
        if (!snapshot.val()) {
            dispatch({
                type: FETCH_LANGUAGE_FAILED,
                payload: "No Languages available.",
            });
            return;
        }

        const data = snapshot.val();

        let defaultLanguage = null;
        let defaultLangLocale = "fr";

        const langlist = Object.keys(data).map((i) => {
            data[i].id = i;
            if (data[i].default) {
                defaultLanguage = data[i].keyValuePairs;
                defaultLangLocale = data[i].langLocale || defaultLangLocale;
            }
            return data[i];
        });

        // [I18N_FIX] Build map: { fr: keyValuePairs, en: keyValuePairs, ... }
        const langMap = {};
        langlist.forEach((l) => {
            if (l?.langLocale && l?.keyValuePairs) {
                langMap[l.langLocale] = l.keyValuePairs;
            }
        });

        dispatch({
            type: FETCH_LANGUAGE_SUCCESS,
            payload: {
                defaultLanguage,      // legacy (DB default)
                defaultLangLocale,    // NEW
                langlist,             // existing
                langMap,              // NEW
            },
        });
    });
};

export const editLanguage = (lang, method) => (dispatch) => {
    const {
        languagesRef,
        languagesEditRef
    } = firebase;
    dispatch({
        type: EDIT_LANGUAGE,
        payload: { lang, method }
    });
    if (method === 'Add') {
        return push(languagesRef, lang);
    } else if (method === 'Delete') {
        return remove(languagesEditRef(lang.id));
    } else {
        return set(languagesEditRef(lang.id), lang);
    }
}


export const convertLanguage = async (word, userLangLocale) => {
    const {
        languagesRef,
        langEditRef,
        config,
    } = firebase;

    if (!word) return;
    let langKey = getLangKey(word);

    onValue(languagesRef, async (snapshot) => {
        if (snapshot.val()) {
            const data = snapshot.val();
            const langLocaleArr = Object.keys(data).map(i => {
                data[i].id = i;
                return { langLocale: data[i].langLocale, id: data[i].id }
            });

            let defLangLocale = "";

            if (userLangLocale) {
                defLangLocale = userLangLocale;
            } else {
                const defLocale = Object.keys(data).filter(i => {
                    data[i].id = i;
                    return data[i].default === true;
                })[0];

                defLangLocale = defLocale && data[defLocale] ? data[defLocale].langLocale : "fr";
            }

            for (let j = 0; j < langLocaleArr.length; j++) {
                try {
                    if (langLocaleArr[j].langLocale === defLangLocale) {
                        update(langEditRef(langLocaleArr[j].id), { [langKey]: word });
                        const region = (typeof process !== "undefined" && (process.env?.REACT_APP_FUNCTIONS_REGION || process.env?.FUNCTIONS_REGION)) || firebase.config?.functionsRegion || "europe-west1";
                        const projectId = config?.projectId || firebase.config?.projectId || "drive2go-c806b";
                        const functionsUrl = (typeof process !== "undefined" && process.env?.REACT_APP_FUNCTIONS_URL)
                            ? process.env.REACT_APP_FUNCTIONS_URL.replace(/\/+$/, '')
                            : `https://${region}-${projectId}.cloudfunctions.net`;
                        const response = await fetch(`${functionsUrl}/gettranslation?str=${encodeURIComponent(word)}&from=${encodeURIComponent(defLangLocale)}&to=${encodeURIComponent(langLocaleArr[j].langLocale)}`, {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        });
                        const json = await response.json();
                        if (json && json.text) {
                            update(langEditRef(langLocaleArr[j].id), { [langKey]: json.text });
                        }
                    }
                }
                catch (err) {
                    console.log("errror occured in language add", err);
                };
            }
        }
    }, { onlyOnce: true });

}